import {useState, createContext} from 'react';

const APIObjectsContext = createContext();
export default APIObjectsContext;

/**
 * Here is where all objects of the API's used will be stored as well as functions used in components requiring something related to those API objects
 *
 **/
export const APIObjectsProvider = ({children}) => {
  //dermadetect API
  const [anamnesisObject, setAnamnesisObject] = useState({});
  const [anamnesisObjectAdditionalDataValues, setAnamnesisObjectAdditionalDataValues] = useState({});
  const [anamnesisObjectQuestionKeysHistory, setAnamnesisObjectQuestionKeysHistory] = useState([]);
  // HeHealth API
  const [caseObject, setCaseObject] = useState({});
  const [caseObjectAdditionalDataValues, setCaseObjectAdditionalDataValues] = useState({});
  const [caseObjectQuestionKeysHistory, setCaseObjectQuestionKeysHistory] = useState([]);
  // assessment endpoint
  const [userAssessmentID, setUserAssessmentID] = useState(undefined);

  const contextData = {
    // DermaDetect API
    anamnesisObject,
    setAnamnesisObject,
    anamnesisObjectAdditionalDataValues,
    setAnamnesisObjectAdditionalDataValues,
    anamnesisObjectQuestionKeysHistory,
    setAnamnesisObjectQuestionKeysHistory,
    // HeHealth API
    caseObject,
    setCaseObject,
    caseObjectAdditionalDataValues,
    setCaseObjectAdditionalDataValues,
    caseObjectQuestionKeysHistory,
    setCaseObjectQuestionKeysHistory,

    userAssessmentID,
    setUserAssessmentID,
  };
  return <APIObjectsContext.Provider value={contextData}>{children}</APIObjectsContext.Provider>;
};
